module.exports = __webpack_public_path__ + "images/category_lp/pc/media7_84c9110e50dc965792f2e5033e0082a6.jpg";